module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./~/@aws-amplify/api/~/aws-sdk/apis/cognito-identity-2014-06-30.paginators.json
// module id = 471
// module chunks = 1